import React, { useEffect, useState } from 'react';
import SchemaModal from '../../../ui/SchemaModal';
import Form from '../../../ui/Form';

const MODES = {
  scry: { title: 'Scry', hint: 'Wie viele Karten von oben ansehen?' },
  mill: { title: 'Mill', hint: 'Wie viele Karten von oben in den Friedhof legen?' },
};

/**
 * Anzahl für Scry oder Mill wählen.
 *
 *   <ScryMillDialog open={open} mode="mill" max={deck.length} onConfirm={(n) => mill(n)}
 *     onOpenChange={setOpen} />
 *
 * - `SchemaModal size="sm"`, die Frage als Untertitel, darunter `Form.Stepper` (1 bis `max`,
 *   Start bei 1 je Öffnen).
 * - „Bestätigen" ruft `onConfirm(anzahl)` und schließt den Dialog; bei `max < 1` (leere
 *   Bibliothek) ist er gesperrt.
 * - „Scry"/„Mill" sind die Magic-Begriffe und bleiben englisch.
 */
export default function ScryMillDialog({ open, mode = 'scry', max = 1, onConfirm, onOpenChange }) {
  const [count, setCount] = useState(1);
  const { title, hint } = MODES[mode] || MODES.scry;
  const upper = Math.max(max, 1);

  useEffect(() => {
    if (open) setCount(1);
  }, [open]);

  const confirm = () => {
    onConfirm?.(Math.min(count, upper));
    onOpenChange?.(false);
  };

  return (
    <SchemaModal
      open={open}
      onOpenChange={onOpenChange}
      size="sm"
      title={title}
      description={hint}
      footer={(
        <>
          <button type="button" className="btn-secondary" onClick={() => onOpenChange?.(false)}>
            Abbrechen
          </button>
          <button type="button" className="btn-primary" onClick={confirm} disabled={max < 1}>
            Bestätigen
          </button>
        </>
      )}
    >
      <Form.Stepper value={count} min={1} max={upper} onChange={setCount} ariaLabel="Anzahl" />
    </SchemaModal>
  );
}
